import { useDropzone } from "react-dropzone";
// import { useEffect } from 'react';
import urlToHttp from "../utils/urlToHttp";
const ImageUploader = (props) => {
  const { formik } = props;
  const { getRootProps, getInputProps } = useDropzone({
    noDrag: true,
    accept: {
      "image/*": [".png", ".gif", ".jpeg", ".jpg", ".webp"],
    },
    maxSize: 35 * 1024 * 1024,
    maxFiles: 1,
    onDrop: (acceptedFiles) => {
      // setFiles(
      //   // eslint-disable-next-line
      //   acceptedFiles.map((file) => {
      //     return Object.assign(file, {
      //       preview: URL.createObjectURL(file),
      //     });
      //   })
      // );
      if (acceptedFiles[0] !== undefined) {
        formik.setFieldValue(
          "thumbnail",
          Object.assign(acceptedFiles[0], {
            preview: URL.createObjectURL(acceptedFiles[0]),
          })
        );
      }
    },
  });

  return (
    <div>
      <label className="label-form" htmlFor="grid-Thumbnail">
        Image
        <p className="ml-1 text-warning">*</p>
      </label>
      <div
        {...getRootProps({ className: "dropzone" })}
        id="createpage-image-dropzone"
      >
        <input {...getInputProps()} id="createpage-image-input" />
        {formik.values.thumbnail ? (
          <img
            id="createpage-image-preview"
            aria-label="createpage-image-preview"
            className="mb-6 h-40"
            src={
              formik.values.thumbnail.preview
                ? formik.values.thumbnail.preview
                : urlToHttp(formik.values.thumbnail)[0]
            }
            alt="upload"
          />
        ) : (
          <div
            className="pointer-events-auto mb-6 flex h-40 w-60 flex-col items-center justify-center border border-gray_e4"
            id="createpage-image-undefined"
            aria-label="createpage-image-undefined"
          >
            <div
              className=" border-primary text-primary border rounded-full w-[30px] h-[30px] flex items-center justify-center text-3xl leading-none"
              text-primary
            >
              <span className="-mt-1">+</span>
            </div>
          </div>
        )}
      </div>
      {formik.errors.thumbnail && formik.touched.thumbnail ? (
        <p
          className="text-red-500"
          id="createpage-image-errormsg"
          aria-label="createpage-image-errormsg"
        >
          {formik.errors.thumbnail}
        </p>
      ) : null}
    </div>
  );
};

export default ImageUploader;
